import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { function_CON_OperacionesParaImportar_Insertar, function_CON_OperacionesParaImportar_Leer, function_CON_OperacionesParaImportar_Modificar } from "neftis7_apicaller/src/funciones/CONT/CON_OperacionesParaImportar";
import { CheckBox, DateBox, NumberBox, RadioGroup, TextBox } from "devextreme-react";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";
import ComboAbmConCuentasFinancieras from "../../Componentes/Compuestos/Combos/ComboAbmConCuentasFinancieras";
import ComboAbmConSubCentrosCosto from "../../Componentes/Compuestos/Combos/ComboAbmConSubCentrosCosto";
import LVNumberBoxDocumento from "../../Componentes/Compuestos/Complejos/LVNumberBoxDocumento";
import ComboVenDocsVentaTipos from "../../Componentes/Compuestos/Combos/ComboVenDocsVentaTipos";
import ComboAbmArtArticulos from "../../Componentes/Compuestos/Combos/ComboAbmArtArticulos";
import ComboAbmEexClientes from "../../Componentes/Compuestos/Combos/ComboAbmEexClientes";
import ComboAbmEexProveedores from "../../Componentes/Compuestos/Combos/ComboAbmEexProveedores";
import LVSelectorImportarOperaciones from "../../Componentes/Selectores/LVSelectorImportarOperaciones";

export const CON_OperacionesParaImportar_ModificacionCreacion = (props) => {

  let Codigo = useParams()
  const [loading, setLoading] = useState(true);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [fecha, setFecha] = useState(new Date());
  const [fechaVencimiento, setFechaVencimiento] = useState(new Date());
  const [cantidad, setCantidad] = useState(1);
  const [idItemAsignado, setIdItemAsignado] = useState(0);
  const [codigoArticulo, setCodigoArticulo] = useState("")
  const [codigoPresentacion, setCodigoPresentacion] = useState("DEF")
  const [codigoTamano, setCodigoTamano] = useState("DEF")
  const [codigoUnidadMedida, setCodigoUnidadMedida] = useState("UN")
  const [descripcion, setDescripcion] = useState("");
  const [importe, setImporte] = useState(0);
  const [idTipoOperacion, setIdTipoOperacion] = useState(1);
  const [sinPagoRecibo, setSinPagoRecibo] = useState(false);
  const [ocultarImportes, setOcultarImportes] = useState(true);
  const [codigoUbicacionIngreso, setCodigoUbicacionIngreso] = useState("");
  const [codigoSubCC, setCodigoSubCC] = useState("");
  const [codigoCuentaFinanciera, setCodigoCuentaFinanciera] = useState("");
  const [cuotas, setCuotas] = useState(1);
  const [idOperacion1, setIdOperacion1] = useState(0);
  const [idOperacion2, setIdOperacion2] = useState(0);
  const [idEstado, setIdEstado] = useState(10);
  const [idCliente, setIdCliente] = useState(0);
  const [idProveedor, setIdProveedor] = useState(0);
  const [codigoMoneda, setCodigoMoneda] = useState("PA");
  const [cotizacion, setCotizacion] = useState(1);
  const [factura, setFactura] = useState("");
  const [idTipoDocumento, setIdTipoDocumento] = useState(11);
  const [importePercepcionIIBB, setImportePercepcionIIBB] = useState(0);
  const [importePercepcionIVA, setImportePercepcionIVA] = useState(0);
  const [importePercepcionSUSS, setImportePercepcionSUSS] = useState(0);
  const [importePercepcionGanancias, setImportePercepcionGanancias] = useState(0);
  const [importePercepcionImpuestosInternos, setImportePercepcionImpuestosInternos] = useState(0);
  const [comprobantePercepcionIIBB, setComprobantePercepcionIIBB] = useState("");
  const [comprobantePercepcionIVA, setComprobantePercepcionIVA] = useState("");
  const [comprobantePercepcionSUSS, setComprobantePercepcionSUSS] = useState("");
  const [comprobantePercepcionGanancias, setComprobantePercepcionGanancias] = useState("");
  const [comprobantePercepcionImpuestosInternos, setComprobantePercepcionImpuestosInternos] = useState("");
  const [importeRetencionIIBB, setImporteRetencionIIBB] = useState(0);
  const [importeRetencionIVA, setImporteRetencionIVA] = useState(0);
  const [importeRetencionSUSS, setImporteRetencionSUSS] = useState(0);
  const [importeRetencionGanancias, setImporteRetencionGanancias] = useState(0);
  const [importeRetencionImpuestosInternos, setImporteRetencionImpuestosInternos] = useState(0);
  const [comprobanteRetencionIIBB, setComprobanteRetencionIIBB] = useState("");
  const [comprobanteRetencionIVA, setComprobanteRetencionIVA] = useState("");
  const [comprobanteRetencionSUSS, setComprobanteRetencionSUSS] = useState("");
  const [comprobanteRetencionGanancias, setComprobanteRetencionGanancias] = useState("");
  const [comprobanteRetencionImpuestosInternos, setComprobanteRetencionImpuestosInternos] = useState("");
  const [importeExento, setImporteExento] = useState(0);
  const [importeIVA10, setImporteIVA10] = useState(0);
  const [importeIVA21, setImporteIVA21] = useState(0);
  const [importeIVA27, setImporteIVA27] = useState(0);
  const [importeTotal, setImporteTotal] = useState(0);
  const [codigoCuentaContableDocCompraVenta, setCodigoCuentaContableDocCompraVenta] = useState("");
  const [codigoCuentaContablePagoRecibo, setCodigoCuentaContablePagoRecibo] = useState("");
  const [ncPorcentaje, setNcPorcentaje] = useState(0);
  const [ncIdProveedor, setNcIdProveedor] = useState(0);
  const [socio1Porcentaje, setSocio1Porcentaje] = useState(0);
  const [socio1IdPersona, setSocio1IdPersona] = useState(0);
  const [socio2Porcentaje, setSocio2Porcentaje] = useState(0);
  const [socio2IdPersona, setSocio2IdPersona] = useState(0);
  const [socio3Porcentaje, setSocio3Porcentaje] = useState(0);
  const [socio3IdPersona, setSocio3IdPersona] = useState(0);
  const [socio4Porcentaje, setSocio4Porcentaje] = useState(0);
  const [socio4IdPersona, setSocio4IdPersona] = useState(0);
  const [ndPorcentaje, setNdPorcentaje] = useState(0);
  const [ndIdProveedor, setNdIdProveedor] = useState(0);
  const [showPopupAdquirirClonar, setShowPopupAdquirirClonar] = useState(false);
  const [idOperacionParaAdquirirClonar, setIdOperacionParaAdquirirClonar] = useState(0);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);


  const [objetoParaFabricar, setObjetoParaFabricar] = useState([]);

  const onClickAgregar = () => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);
      
      if (cantidad < 1) {
        alert("La cantidad debe ser mayor a cero.");
        return;
      }

      if (!codigoArticulo || codigoArticulo === "") {
        alert("Es necesario seleccionar un Artículo.");
        return;
      }

      if (!codigoPresentacion || codigoPresentacion === "") {
        alert("Es necesario seleccionar un Artículo.");
        return;
      }

      if (!codigoTamano || codigoTamano === "") {
        alert("Es necesario seleccionar un Artículo.");
        return;
      }

      if (!codigoUnidadMedida || codigoUnidadMedida === "") {
        alert("Es necesario seleccionar un Artículo.");
        return;
      }

      const Agregar = async () => {
        const dataOperacion = {
          IdItem: idItemAsignado,
          Fecha: await FormateoFechaPara_yyyyMMdd_HHmmss(fecha),
          FechaVencimiento: await FormateoFechaPara_yyyyMMdd_HHmmss(fechaVencimiento),
          CodigoCompania: localStorage.getItem("CodigoCompania"),
          CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
          CodigoPlanta: localStorage.getItem("CodigoPlanta"),
          Terminal: localStorage.getItem("Terminal"),
          Descripcion: descripcion,
          Importe: importe,
          IdTipoOperacion: idTipoOperacion,
          Cantidad: cantidad,
          CodigoArticulo: codigoArticulo,
          CodigoPresentacion: codigoPresentacion,
          CodigoTamano: codigoTamano,
          CodigoUnidadMedida: codigoUnidadMedida,
          CodigoUbicacionIngreso: codigoUbicacionIngreso,
          CodigoSubCC: codigoSubCC,
          CodigoCuentaFinanciera: codigoCuentaFinanciera,
          Cuotas: cuotas,
          IdOperacion1: idOperacion1,
          IdOperacion2: idOperacion2,
          IdEstado: idEstado,
          IdCliente: idCliente,
          IdProveedor: idProveedor,
          IdUsuarioAuditoria: localStorage.getItem("IdPersona"),
          CodigoMoneda: codigoMoneda,
          Cotizacion: cotizacion,
          Factura: factura.numeroFantasia,
          IdTipoDocumento: idTipoDocumento,
          ImportePercepcionIIBB: importePercepcionIIBB,
          ImportePercepcionIVA: importePercepcionIVA,
          ImportePercepcionSUSS: importePercepcionSUSS,
          ImportePercepcionGanancias: importePercepcionGanancias,
          ImportePercepcionImpuestosInternos: importePercepcionImpuestosInternos,
          ComprobantePercepcionIIBB: comprobantePercepcionIIBB,
          ComprobantePercepcionIVA: comprobantePercepcionIVA,
          ComprobantePercepcionSUSS: comprobantePercepcionSUSS,
          ComprobantePercepcionGanancias: comprobantePercepcionGanancias,
          ComprobantePercepcionImpuestosInternos: comprobantePercepcionImpuestosInternos,
          ImporteRetencionIIBB: importeRetencionIIBB,
          ImporteRetencionIVA: importeRetencionIVA,
          ImporteRetencionSUSS: importeRetencionSUSS,
          ImporteRetencionGanancias: importeRetencionGanancias,
          ImporteRetencionImpuestosInternos: importeRetencionImpuestosInternos,
          ComprobanteRetencionIIBB: comprobanteRetencionIIBB,
          ComprobanteRetencionIVA: comprobanteRetencionIVA,
          ComprobanteRetencionSUSS: comprobanteRetencionSUSS,
          ComprobanteRetencionGanancias: comprobanteRetencionGanancias,
          ComprobanteRetencionImpuestosInternos: comprobanteRetencionImpuestosInternos,
          ImporteExento: importeExento,
          ImporteIVA10: importeIVA10,
          ImporteIVA21: importeIVA21,
          ImporteIVA27: importeIVA27,
          CodigoCuentaContableDocCompraVenta: codigoCuentaContableDocCompraVenta,
          CodigoCuentaContablePagoRecibo: codigoCuentaContablePagoRecibo,
          NCPorcentaje: ncPorcentaje,
          NCIdProveedor: ncIdProveedor,
          Socio1Porcentaje: socio1Porcentaje,
          Socio1IdPersona: socio1IdPersona,
          Socio2Porcentaje: socio2Porcentaje,
          Socio2IdPersona: socio2IdPersona,
          Socio3Porcentaje: socio3Porcentaje,
          Socio3IdPersona: socio3IdPersona,
          Socio4Porcentaje: socio4Porcentaje,
          Socio4IdPersona: socio4IdPersona,
          NDPorcentaje: ndPorcentaje,
          NDIdProveedor: ndIdProveedor

        };

        if (Codigo.Codigo === "--NUEVO--") {
          const resultIdOperacion = await function_CON_OperacionesParaImportar_Insertar(dataOperacion)

          alert("Se ha creado la Operación Nº " + resultIdOperacion.data.codigoGenerado)
        } else {
          const resultIdOperacion = await function_CON_OperacionesParaImportar_Modificar(dataOperacion)

          alert("Se ha modificado la Operación Nº: " + Codigo.Codigo)
        }
      }

      Agregar();
    } catch (error) {
      alert(error);
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  const handleOpen_AdquirirClonar = async (e) => {
    setShowPopupAdquirirClonar(true)
    setIdOperacionParaAdquirirClonar(0)
  };

  const handleClose_AdquirirClonar = () => {
    setShowPopupAdquirirClonar(false)
    setIdOperacionParaAdquirirClonar(0)
  };

  const handleConfirmAdquirirClonar = (idOperacion) => {
    if (idOperacion != 0 && idOperacion != undefined) {
      setShowPopupAdquirirClonar(false)
      setIdOperacionParaAdquirirClonar(idOperacion)
    } else {
      setShowPopupAdquirirClonar(false)
      setIdOperacionParaAdquirirClonar(0)
    }
  };

  useEffect(() => {
    setImporteTotal(importe + importeExento + importeIVA10 + importeIVA21 + importeIVA27 + importePercepcionGanancias + importePercepcionIIBB + importePercepcionIVA + importePercepcionImpuestosInternos + importePercepcionSUSS);
  }, [importe, importeExento, importeIVA10, importeIVA21, importeIVA27, importePercepcionGanancias, importePercepcionIIBB, importePercepcionIVA, importePercepcionImpuestosInternos, importePercepcionSUSS, importeRetencionGanancias, importeRetencionIIBB, importeRetencionIVA, importeRetencionImpuestosInternos, importeRetencionSUSS]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        let datosDocClonable

        if (idOperacionParaAdquirirClonar) {
          datosDocClonable = await function_CON_OperacionesParaImportar_Leer(idOperacionParaAdquirirClonar)

          if (datosDocClonable && datosDocClonable.data) {
            setCantidad(datosDocClonable.data[0].Cantidad)
            setCodigoArticulo(datosDocClonable.data[0].CodigoArticulo)
            setCodigoPresentacion(datosDocClonable.data[0].CodigoPresentacion)
            setCodigoTamano(datosDocClonable.data[0].CodigoTamano)
            setCodigoUnidadMedida(datosDocClonable.data[0].CodigoUnidadMedida)
            setDescripcion(datosDocClonable.data[0].Descripcion)

            setImporte(datosDocClonable.data[0].Importe)
            setIdTipoOperacion(datosDocClonable.data[0].IdTipoOperacion)
            setCodigoUbicacionIngreso(datosDocClonable.data[0].CodigoUbicacionIngreso)
            setCodigoSubCC(datosDocClonable.data[0].CodigoSubCC)
            setCodigoCuentaFinanciera(datosDocClonable.data[0].CodigoCuentaFinanciera)
            if (datosDocClonable.data[0].CodigoCuentaFinanciera === "S.P-R") {
              setSinPagoRecibo(true)
            } else {
              setSinPagoRecibo(false)
            }
            setCuotas(datosDocClonable.data[0].Cuotas)
            setIdCliente(datosDocClonable.data[0].IdCliente)
            setIdProveedor(datosDocClonable.data[0].IdProveedor)
            setCodigoMoneda(datosDocClonable.data[0].CodigoMoneda)
            setCotizacion(datosDocClonable.data[0].Cotizacion)
            setIdTipoDocumento(datosDocClonable.data[0].IdTipoDocumento)
            setImportePercepcionIIBB(datosDocClonable.data[0].ImportePercepcionIIBB)
            setImportePercepcionIVA(datosDocClonable.data[0].ImportePercepcionIVA)
            setImportePercepcionSUSS(datosDocClonable.data[0].ImportePercepcionSUSS)
            setImportePercepcionGanancias(datosDocClonable.data[0].ImportePercepcionGanancias)
            setImportePercepcionImpuestosInternos(datosDocClonable.data[0].ImportePercepcionImpuestosInternos)
            setComprobantePercepcionIIBB(datosDocClonable.data[0].ComprobantePercepcionIIBB)
            setComprobantePercepcionIVA(datosDocClonable.data[0].ComprobantePercepcionIVA)
            setComprobantePercepcionSUSS(datosDocClonable.data[0].ComprobantePercepcionSUSS)
            setComprobantePercepcionGanancias(datosDocClonable.data[0].ComprobantePercepcionGanancias)
            setComprobantePercepcionImpuestosInternos(datosDocClonable.data[0].ComprobantePercepcionImpuestosInternos)
            setImporteRetencionIIBB(datosDocClonable.data[0].ImporteRetencionIIBB)
            setImporteRetencionIVA(datosDocClonable.data[0].ImporteRetencionIVA)
            setImporteRetencionSUSS(datosDocClonable.data[0].ImporteRetencionSUSS)
            setImporteRetencionGanancias(datosDocClonable.data[0].ImporteRetencionGanancias)
            setImporteRetencionImpuestosInternos(datosDocClonable.data[0].ImporteRetencionImpuestosInternos)
            setComprobanteRetencionIIBB(datosDocClonable.data[0].ComprobanteRetencionIIBB)
            setComprobanteRetencionIVA(datosDocClonable.data[0].ComprobanteRetencionIVA)
            setComprobanteRetencionSUSS(datosDocClonable.data[0].ComprobanteRetencionSUSS)
            setComprobanteRetencionGanancias(datosDocClonable.data[0].ComprobanteRetencionGanancias)
            setComprobanteRetencionImpuestosInternos(datosDocClonable.data[0].ComprobanteRetencionImpuestosInternos)
            setImporteExento(datosDocClonable.data[0].ImporteExento)
            setImporteIVA10(datosDocClonable.data[0].ImporteIVA10)
            setImporteIVA21(datosDocClonable.data[0].ImporteIVA21)
            setImporteIVA27(datosDocClonable.data[0].ImporteIVA27)
            setImporteTotal(datosDocClonable.data[0].ImporteTotal)
            setCodigoCuentaContableDocCompraVenta(datosDocClonable.data[0].CodigoCuentaContableDocCompraVenta)
            setCodigoCuentaContablePagoRecibo(datosDocClonable.data[0].CodigoCuentaContablePagoRecibo)
            setNcPorcentaje(datosDocClonable.data[0].NcPorcentaje)
            setNcIdProveedor(datosDocClonable.data[0].NcIdProveedor)
            setSocio1Porcentaje(datosDocClonable.data[0].Socio1Porcentaje)
            setSocio1IdPersona(datosDocClonable.data[0].Socio1IdPersona)
            setSocio2Porcentaje(datosDocClonable.data[0].Socio2Porcentaje)
            setSocio2IdPersona(datosDocClonable.data[0].Socio2IdPersona)
            setSocio3Porcentaje(datosDocClonable.data[0].Socio3Porcentaje)
            setSocio3IdPersona(datosDocClonable.data[0].Socio3IdPersona)
            setSocio4Porcentaje(datosDocClonable.data[0].Socio4Porcentaje)
            setSocio4IdPersona(datosDocClonable.data[0].Socio4IdPersona)
            setNdPorcentaje(datosDocClonable.data[0].NdPorcentaje)
            setNdIdProveedor(datosDocClonable.data[0].NdIdProveedor)
            setShowPopupAdquirirClonar(datosDocClonable.data[0].ShowPopupAdquirirClonar)
            setIdOperacionParaAdquirirClonar(datosDocClonable.data[0].IdOperacionParaAdquirirClonar)
          }
        }
        setLoading(false);
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, [idOperacionParaAdquirirClonar]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")
        } else {
          setTituloBoton("ACTUALIZAR ID " + Codigo.Codigo)
          setAccionBoton("ACTUALIZAR ID " + Codigo.Codigo)

          let datosDocClonable = await function_CON_OperacionesParaImportar_Leer(Codigo.Codigo)

          if (datosDocClonable && datosDocClonable.data) {
            setIdItemAsignado(Codigo.Codigo)
            setFecha(datosDocClonable.data[0].Fecha)
            setFechaVencimiento(datosDocClonable.data[0].FechaVencimiento)
            setCantidad(datosDocClonable.data[0].Cantidad)
            setCodigoArticulo(datosDocClonable.data[0].CodigoArticulo)
            setCodigoPresentacion(datosDocClonable.data[0].CodigoPresentacion)
            setCodigoTamano(datosDocClonable.data[0].CodigoTamano)
            setCodigoUnidadMedida(datosDocClonable.data[0].CodigoUnidadMedida)
            setDescripcion(datosDocClonable.data[0].Descripcion)

            setImporte(datosDocClonable.data[0].Importe)
            setIdTipoOperacion(datosDocClonable.data[0].IdTipoOperacion)
            setCodigoUbicacionIngreso(datosDocClonable.data[0].CodigoUbicacionIngreso)
            setCodigoSubCC(datosDocClonable.data[0].CodigoSubCC)
            setCodigoCuentaFinanciera(datosDocClonable.data[0].CodigoCuentaFinanciera)
            if (datosDocClonable.data[0].CodigoCuentaFinanciera === "S.P-R") {
              setSinPagoRecibo(true)
            } else {
              setSinPagoRecibo(false)
            }
            setCuotas(datosDocClonable.data[0].Cuotas)
            setIdCliente(datosDocClonable.data[0].IdCliente)
            setIdProveedor(datosDocClonable.data[0].IdProveedor)
            setCodigoMoneda(datosDocClonable.data[0].CodigoMoneda)
            setCotizacion(datosDocClonable.data[0].Cotizacion)
            setIdTipoDocumento(datosDocClonable.data[0].IdTipoDocumento)
            setImportePercepcionIIBB(datosDocClonable.data[0].ImportePercepcionIIBB)
            setImportePercepcionIVA(datosDocClonable.data[0].ImportePercepcionIVA)
            setImportePercepcionSUSS(datosDocClonable.data[0].ImportePercepcionSUSS)
            setImportePercepcionGanancias(datosDocClonable.data[0].ImportePercepcionGanancias)
            setImportePercepcionImpuestosInternos(datosDocClonable.data[0].ImportePercepcionImpuestosInternos)
            setComprobantePercepcionIIBB(datosDocClonable.data[0].ComprobantePercepcionIIBB)
            setComprobantePercepcionIVA(datosDocClonable.data[0].ComprobantePercepcionIVA)
            setComprobantePercepcionSUSS(datosDocClonable.data[0].ComprobantePercepcionSUSS)
            setComprobantePercepcionGanancias(datosDocClonable.data[0].ComprobantePercepcionGanancias)
            setComprobantePercepcionImpuestosInternos(datosDocClonable.data[0].ComprobantePercepcionImpuestosInternos)
            setImporteRetencionIIBB(datosDocClonable.data[0].ImporteRetencionIIBB)
            setImporteRetencionIVA(datosDocClonable.data[0].ImporteRetencionIVA)
            setImporteRetencionSUSS(datosDocClonable.data[0].ImporteRetencionSUSS)
            setImporteRetencionGanancias(datosDocClonable.data[0].ImporteRetencionGanancias)
            setImporteRetencionImpuestosInternos(datosDocClonable.data[0].ImporteRetencionImpuestosInternos)
            setComprobanteRetencionIIBB(datosDocClonable.data[0].ComprobanteRetencionIIBB)
            setComprobanteRetencionIVA(datosDocClonable.data[0].ComprobanteRetencionIVA)
            setComprobanteRetencionSUSS(datosDocClonable.data[0].ComprobanteRetencionSUSS)
            setComprobanteRetencionGanancias(datosDocClonable.data[0].ComprobanteRetencionGanancias)
            setComprobanteRetencionImpuestosInternos(datosDocClonable.data[0].ComprobanteRetencionImpuestosInternos)
            setImporteExento(datosDocClonable.data[0].ImporteExento)
            setImporteIVA10(datosDocClonable.data[0].ImporteIVA10)
            setImporteIVA21(datosDocClonable.data[0].ImporteIVA21)
            setImporteIVA27(datosDocClonable.data[0].ImporteIVA27)
            setImporteTotal(datosDocClonable.data[0].ImporteTotal)
            setCodigoCuentaContableDocCompraVenta(datosDocClonable.data[0].CodigoCuentaContableDocCompraVenta)
            setCodigoCuentaContablePagoRecibo(datosDocClonable.data[0].CodigoCuentaContablePagoRecibo)
            setNcPorcentaje(datosDocClonable.data[0].NcPorcentaje)
            setNcIdProveedor(datosDocClonable.data[0].NcIdProveedor)
            setSocio1Porcentaje(datosDocClonable.data[0].Socio1Porcentaje)
            setSocio1IdPersona(datosDocClonable.data[0].Socio1IdPersona)
            setSocio2Porcentaje(datosDocClonable.data[0].Socio2Porcentaje)
            setSocio2IdPersona(datosDocClonable.data[0].Socio2IdPersona)
            setSocio3Porcentaje(datosDocClonable.data[0].Socio3Porcentaje)
            setSocio3IdPersona(datosDocClonable.data[0].Socio3IdPersona)
            setSocio4Porcentaje(datosDocClonable.data[0].Socio4Porcentaje)
            setSocio4IdPersona(datosDocClonable.data[0].Socio4IdPersona)
            setNdPorcentaje(datosDocClonable.data[0].NdPorcentaje)
            setNdIdProveedor(datosDocClonable.data[0].NdIdProveedor)
            setShowPopupAdquirirClonar(datosDocClonable.data[0].ShowPopupAdquirirClonar)
            setIdOperacionParaAdquirirClonar(datosDocClonable.data[0].IdOperacionParaAdquirirClonar)
          }
        }
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);

  return (
    <PaginaCarga
      Titulo="OPERACIONES"
    >
      <div className="LV-GroupBox-div" style={{ marginBottom: '10px', alignItems: 'center', textAlign: 'center' }}>
        <LVButtonAccion Texto={"CLONAR OPERACIÓN ANTERIOR"} onClick={handleOpen_AdquirirClonar} />
        {showPopupAdquirirClonar ? (
          <>
            <LVSelectorImportarOperaciones
              onConfirm={(idOperacion) => handleConfirmAdquirirClonar(idOperacion)}
              onClose={handleClose_AdquirirClonar} />
          </>
        ) : null}
      </div>

      <div className="LV-GroupBox-div"
        style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center' }}
      >
        <div className="LV-FlexContainer" style={{ gap: 42, marginBottom: 10 }}>
          Fecha:
          <DateBox width={140} displayFormat="dd/MM/yyyy"
            value={fecha}
            style={{ marginLeft: '5px', marginRight: '20px' }}
            onValueChanged={(e) => setFecha(e.value)} />

          Vencimiento:
          <DateBox width={140} displayFormat="dd/MM/yyyy"
            value={fecha}
            style={{ marginLeft: '5px', marginRight: '20px' }}
            onValueChanged={(e) => setFechaVencimiento(e.value)} />

          <RadioGroup
            items={["Compra", "Venta"]}
            defaultValue="Compra"
            value={idTipoOperacion === 1 ? "Compra" : "Venta"}
            onValueChanged={(e) => {
              const valorSeleccionado = e.value;
              if (valorSeleccionado === "Compra") {
                setIdTipoOperacion(1);
              } else if (valorSeleccionado === "Venta") {
                setIdTipoOperacion(4);
              }
            }}
            layout="horizontal"
          />

          <ComboVenDocsVentaTipos
            onValueChanged={(e) => {
              setIdTipoDocumento(e.value);
              const tiposOcultar = [11, 12, 13, 21, 22, 23, 41, 42, 43, 61, 62, 63, 71, 72, 73];
              if (tiposOcultar.includes(e.value)) {
                setOcultarImportes(true);
              } else {
                setOcultarImportes(false);
              }
            }}
            value={idTipoDocumento}
            ancho="310"
          />

          <LVNumberBoxDocumento
            NumeracionLibre={true}
            IdTipo={0}
            IdTipoMovimiento={0}
            DatosDocumento={factura}
            SetDatosDocumento={setFactura} />
        </div>

        <div className="LV-FlexContainer" style={{ gap: 42, marginBottom: 10 }}>
          <CheckBox
            text="Sin Pago/Recibo"
            value={sinPagoRecibo}
            onValueChanged={(e) => {
              setSinPagoRecibo(e.value);
              if (e.value) {
                setCodigoCuentaFinanciera("S.P-R");
              } else {
                setCodigoCuentaFinanciera("");
              }
            }}
          />

          {!sinPagoRecibo && (
            <ComboAbmConCuentasFinancieras
              ancho={400}
              IdTipoCuentaFinanciera={0}
              onValueChanged={(e) => setCodigoCuentaFinanciera(e.value)}
              value={codigoCuentaFinanciera}
            />
          )}
        </div>

        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 10 }}>
          <NumberBox width={'20%'} label="Importe" value={importe} onValueChanged={(e) => setImporte(e.value)} />
          {!ocultarImportes && (
            <>
              <NumberBox width={'20%'} label="Neto Exento" value={importeExento} onValueChanged={(e) => setImporteExento(e.value)} />
              <NumberBox width={'20%'} label="I.V.A. 21%" value={importeIVA21} onValueChanged={(e) => setImporteIVA21(e.value)} />
              <NumberBox width={'20%'} label="I.V.A. 10.5%" value={importeIVA10} onValueChanged={(e) => setImporteIVA10(e.value)} />
              <NumberBox width={'20%'} label="I.V.A. 27%" value={importeIVA27} onValueChanged={(e) => setImporteIVA27(e.value)} />
            </>
          )}
        </div>

        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 10 }}>
          <NumberBox width={'9%'} label="Cantidad" value={cantidad} onValueChanged={(e) => setCantidad(e.value)} />
          <NumberBox width={'9%'} label="Cuotas" value={cuotas} onValueChanged={(e) => setCuotas(e.value)} />
          <NumberBox width={'20%'} label="Importe Total" value={importeTotal} onValueChanged={(e) => setImporteTotal(e.value)} readOnly={true} />
        </div>

        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 10 }}>
          <TextBox width={'100%'} label="Descripción" value={descripcion} onValueChanged={(e) => setDescripcion(e.value)} />
        </div>

        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 10 }}>
          <ComboAbmArtArticulos ancho={400} onValueChanged={(e) => setCodigoArticulo(e.value)} value={codigoArticulo} />

          <ComboAbmConSubCentrosCosto ancho={400} onValueChanged={(e) => setCodigoSubCC(e.value)} value={codigoSubCC} />
        </div>

        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 10 }}>

          {idTipoOperacion === 4 && (
            <ComboAbmEexClientes
              ancho={400}
              onValueChanged={(e) => setIdCliente(e.value)}
              value={idCliente}
            />
          )}

          {idTipoOperacion === 1 && (
            <ComboAbmEexProveedores
              ancho={400}
              onValueChanged={(e) => setIdProveedor(e.value)}
              value={idProveedor}
            />
          )}

        </div>

        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 5 }}>
          <NumberBox label="Per. IIBB - Importe" value={importePercepcionIIBB} onValueChanged={(e) => setImportePercepcionIIBB(e.value)} />
          <TextBox label="Per. Comprobante" value={comprobantePercepcionIIBB} onValueChanged={(e) => setComprobantePercepcionIIBB(e.value)} />
          <NumberBox label="Ret. IIBB - Importe" value={importeRetencionIIBB} onValueChanged={(e) => setImporteRetencionIIBB(e.value)} />
          <TextBox label="Ret. Comprobante" value={comprobanteRetencionIIBB} onValueChanged={(e) => setComprobanteRetencionIIBB(e.value)} />
        </div>
        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 5 }}>
          <NumberBox label="Per. IVA - Importe" value={importePercepcionIVA} onValueChanged={(e) => setImportePercepcionIVA(e.value)} />
          <TextBox label="Per. Comprobante" value={comprobantePercepcionIVA} onValueChanged={(e) => setComprobantePercepcionIVA(e.value)} />
          <NumberBox label="Ret. IVA - Importe" value={importeRetencionIVA} onValueChanged={(e) => setImporteRetencionIVA(e.value)} />
          <TextBox label="Ret. Comprobante" value={comprobanteRetencionIVA} onValueChanged={(e) => setComprobanteRetencionIVA(e.value)} />
        </div>
        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 5 }}>
          <NumberBox label="Per. Ganancias - Importe" value={importePercepcionGanancias} onValueChanged={(e) => setImportePercepcionGanancias(e.value)} />
          <TextBox label="Per. Comprobante" value={comprobantePercepcionGanancias} onValueChanged={(e) => setComprobantePercepcionGanancias(e.value)} />
          <NumberBox label="Ret. Ganancias - Importe" value={importeRetencionGanancias} onValueChanged={(e) => setImporteRetencionGanancias(e.value)} />
          <TextBox label="Ret. Comprobante" value={comprobanteRetencionGanancias} onValueChanged={(e) => setComprobanteRetencionGanancias(e.value)} />
        </div>
        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 5 }}>
          <NumberBox label="Per. SUSS - Importe" value={importePercepcionSUSS} onValueChanged={(e) => setImportePercepcionSUSS(e.value)} />
          <TextBox label="Per. Comprobante" value={comprobantePercepcionSUSS} onValueChanged={(e) => setComprobantePercepcionSUSS(e.value)} />
          <NumberBox label="Ret. SUSS - Importe" value={importeRetencionSUSS} onValueChanged={(e) => setImporteRetencionSUSS(e.value)} />
          <TextBox label="Ret. Comprobante" value={comprobanteRetencionSUSS} onValueChanged={(e) => setComprobanteRetencionSUSS(e.value)} />
        </div>
        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 20 }}>
          <NumberBox label="Per. Imp.Int - Importe" value={importePercepcionImpuestosInternos} onValueChanged={(e) => setImportePercepcionImpuestosInternos(e.value)} />
          <TextBox label="Per. Comprobante" value={comprobantePercepcionImpuestosInternos} onValueChanged={(e) => setComprobantePercepcionImpuestosInternos(e.value)} />
          <NumberBox label="Ret. Imp.Int - Importe" value={importeRetencionImpuestosInternos} onValueChanged={(e) => setImporteRetencionImpuestosInternos(e.value)} />
          <TextBox label="Ret. Comprobante" value={comprobanteRetencionImpuestosInternos} onValueChanged={(e) => setComprobanteRetencionImpuestosInternos(e.value)} />
        </div>

        <LVButtonAccion
          Texto="GUARDAR"
          Disabled={cierreEnProceso}
          Ancho={"100%"}
          onClick={onClickAgregar}
        />
      </div>
    </PaginaCarga>
  );
}
